import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { translateMarketingCampaign } from "byzantine";
import utils from "byzantine/src/utils";
import cc from "classcat";

import styles from "./SidebarMarketingCard.module.scss";

import type {
  MarketingCardProps,
  MarketingTarget,
} from "../../../../components/dashboard/MarketingCard/types";

type SidebarMarketingCardProps = MarketingCardProps & {
  config: MarketingTarget;
  linkUrl: string;
  opensInNewTab: boolean;
};

const SidebarMarketingCard = ({
  address,
  config,
  linkUrl,
  opensInNewTab,
}: SidebarMarketingCardProps) => {
  const { l10n } = useLocalization();

  const translatedCampaign = translateMarketingCampaign(
    {
      uuid: address,
      asset_config: {
        title: config.title,
        body: config.body,
        icon: config.icon,
        linkText: config.linkText,
      },
    },
    l10n
  );

  const {
    title,
    body,
    icon,
    linkText: actionText,
  } = translatedCampaign.asset_config || {};

  return (
    <div className={styles["marketing-card"]}>
      <div className={styles["marketing-card-title"]}>
        <span
          className={cc([
            utils.ndsIconPrepend(icon),
            styles["marketing-card-icon"],
          ])}
        />
        <div>{title}</div>
      </div>
      {body}
      <Button
        as="a"
        href={linkUrl}
        kind="plain"
        ariaLabel={`${title} - ${actionText}`}
        label={actionText || "Learn more"}
        testId="marketing-card-learn-more"
        rel="noopener noreferrer"
        target={opensInNewTab ? "_blank" : "_self"}
      />
    </div>
  );
};

export default SidebarMarketingCard;
